import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  fetchMappingData,
  submitMappingData,
} from "../../redux/actions/crmActions";
import { useSelector } from "react-redux";
import { ArrowRight } from "react-bootstrap-icons";
import Toast from "../assetLibComponents/shared/Toast";
import { FaArrowRight } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";


const LeadMapping = (props) => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const mappingData = useSelector((state) => state.crmLeads.fetchMappingData);
  const [newData, setNewData] = useState({});
  const [newArr, setNewArr] = useState();

  useEffect(() => {
    dispatch(fetchMappingData(props.authToken));

    if (mappingData) {
      setNewArr(state?.header);
      function transformArrayToObject(mappingData) {
        const result = {};

        mappingData.forEach((item) => {
          result[item.value] = "";
        });

        return result;
      }
      const transformedObject = transformArrayToObject(mappingData);
      setNewData(transformedObject);
    }
  }, []);

  const handleSelect = (key, value) => {
    // Check if the key exists in the object
    if (newData.hasOwnProperty(key)) {
      // Update the value for the specified key
      const updatedData = { ...newData };

      // Update the value for the specified key
      updatedData[key] = value;
      setNewData(updatedData);
      // const resultArray = state?.header.filter(item => !Object.values(updatedData).includes(item));
      // setNewArr(resultArray)
      // Set the updated state
    } else {
      console.error(`Key '${key}' does not exist in the object.`);
    }
  };

  function hasEmptyValue(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && (obj["domain"] === "" || obj["email"] === "")) {
        return true; // Found a key with an empty value
      }
    }
    return false; // No key with an empty value found
  }
  function addMapping(arr, obj) {
    return arr.map(item => ({
        ...item,
        mapping: obj[item.value]
    }));
}

  const submitHandler = () => {
    if (hasEmptyValue(newData)) {
      Toast("Please fill all the fields", "E");
    } else {
        // dispatch(submitMappingData(props.authToken,payload));
        const newArr = addMapping(mappingData, newData);
        state?.actualArray.map(async (item, index) => {
        await dispatch(submitMappingData(props.authToken, newData, item,newArr));
      });
    }
    
  };

  return (
    <>
      <div className="py-10 mx-10 sm:mx-20">
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">Lead Mapping</div>  
            <button
          onClick={submitHandler}
          type="button"
              className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
            >
            Save Changes
          </button>            
          </div>

      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Zoi Property
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Field Type
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Mapped
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Column Header From File
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {mappingData?.map((item) => (
                    <tr key={item.display}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {item.display}{(item?.value === "email"||item?.value === "domain")&&"*"}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize">{item?.object_type}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{newData[item?.value] !== '' ? <FaCircleCheck className="text-green-500 text-2xl"/>:""}</td>
                      
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><select
                    id="leads"
                    name="leads"
                    onChange={(e) => handleSelect(item.value, e.target.value)}
                    className={`mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[#49BCD2] sm:text-sm sm:leading-6`}
                  >
                    {/* <option value=""></option> */}
                    <option value="">Select {item.display}</option>
                    {newArr?.map((option, i) => (
                      <option
                        key={i}
                        value={option}
                        disabled={Object.values(newData).includes(option)}
                      >
                        {option}
                      </option>
                    ))}
                  </select></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
        {/* <div className="font-bold mb-2">Lead Fields</div>
        {mappingData?.map(
          (item) =>
            item?.object_type == "leads" && (
              <div className="grid grid-cols-12 my-auto">
                <div className="my-auto sm:col-span-3 "></div>
                <div className="my-auto col-span-4 sm:col-span-2 ">{item.display}{item?.value === "email"&&"*"}</div>
                <div className="my-auto col-span-1 "><FaArrowRight className="text-gray-400 border border-solid border-gray-400 p-1 text-2xl"/></div>
                <div className="my-auto col-span-6 sm:col-span-3 ">
                  <select
                    id="leads"
                    name="leads"
                    onChange={(e) => handleSelect(item.value, e.target.value)}
                    className={`mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[#49BCD2] sm:text-sm sm:leading-6`}
                  >
                    <option value="">Select {item.display}</option>
                    {newArr?.map((option, i) => (
                      <option
                        key={i}
                        value={option}
                        disabled={Object.values(newData).includes(option)}
                      >
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )
        )}
        <div className="font-bold my-2">Account Fields</div>
        {mappingData?.map(
          (item) =>
            item?.object_type == "accounts" && (
              <div className="grid grid-cols-12 my-auto">
                <div className="my-auto sm:col-span-3 "></div>
                <div className="my-auto col-span-4 sm:col-span-2 ">{item.display}{item?.value === "domain"&&"*"}</div>
                <div className="my-auto col-span-1 "><FaArrowRight className="text-gray-400 border border-solid border-gray-400 p-1 text-2xl"/></div>
                <div className="my-auto col-span-6 sm:col-span-3 ">
                  <select
                    id="accounts"
                    name="accounts"
                    onChange={(e) => handleSelect(item.value, e.target.value)}
                    className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                  >
                    <option value="">Select {item.display}</option>
                    {newArr?.map((option, i) => (
                      <option
                        key={i}
                        value={option}
                        disabled={Object.values(newData).includes(option)}
                      >
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )
        )} */}
{/* 
        <button
          onClick={submitHandler}
          type="button"
          className="ml-auto mt-10 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
        >
          Submit
          <ArrowRight className="-ml-0.5 h-5 w-5" aria-hidden="true" />
        </button> */}
      </div>
    </>
  );
};

export default LeadMapping;
